import * as React from 'react';

export function useIsInViewport<T extends Element>(
  ref: React.MutableRefObject<T>,
  options: IntersectionObserverInit = {},
) {
  const [isIntersecting, setIsIntersecting] = React.useState(false);

  const observer = React.useMemo(
    () => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting), options),
    [options],
  );

  React.useEffect(() => {
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return { isInViewport: isIntersecting };
}
